import React, { useState } from "react";
import { motion } from "framer-motion";

const sectionVariants = {
  hidden: { opacity: 0, y: 28, scale: 0.985 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1.3,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.16,
    },
  },
};

export default function MotionSection({ children, className = "" }) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <motion.div
      className={`landing-motion-section${isVisible ? " is-visible" : ""} ${className}`.trim()}
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      onViewportEnter={() => setIsVisible(true)}
      viewport={{ once: true, amount: 0.05, margin: "0px" }}
    >
      {children}
    </motion.div>
  );
}